





























































































































































































































































































































































































































































































































































































































import {
	ExchangeRateModel,
	ExchangeRateTypeEnum,
	GroupByProjectionDefinition,
	ProjectionAggregationEnum,
	QueryOperator, ShareModel,
	SortOrder,
	TradeModel,
	TradeTypeEnum,
	TransactionModel,
	WalletModel,
	WalletTransactionModel
} from '@/libs/Api';
import {Component, Ref, Watch} from 'vue-property-decorator';
import {CrudAction} from '@/libs/core/crud/crud-action';
import {createCrudQueryPayload, createGroupedQueryPayload, CrudQueryPredicate} from '@/libs/core/crud/crud-query';
import {CrudGetter} from '@/libs/core/crud/crud-getter';

import CrudTable from '@/libs/common/components/CrudTable.vue';
import {Guid} from '@/libs/common/functions/guid';
import {Constants} from '@/libs/constants/constants';
import Page from '@/Page.vue';
import {tradesStore} from '@/libs/trades/+state/store';
import ApiService from '@/libs/core/api-service';
import {cloneDeep, head} from 'lodash';
import moment from 'moment';
import {exchangeRatesStore} from '@/libs/exchange-rates/+state/store';
import {CrudPageInfo} from '@/libs/core/crud/crud-store-state';
import {sharesStore} from '@/libs/shares/+state/store';

@Component({
    computed: {
        moment() {
            return moment
        }
    },
    methods: {head},
    components: {
        CrudTable
    }
})
export default class ProductNremETrades extends Page {

    headers = [
        { text: 'Klient', align: 'left', sortable: false, value: 'party' },
        { text: 'Typ', align: 'left', sortable: false, value: 'type' },
        { text: 'Počet CP', align: 'left', sortable: false, value: 'fromAmount' },
        { text: 'Částka', align: 'left', sortable: false, value: 'toAmount' },
        { text: 'Kurz', align: 'left', sortable: false, value: 'exchangeRateIm4' },
        { text: 'Datum', align: 'left', sortable: false, value: 'time' },
        { text: 'Zadáno uživatelem', align: 'left', sortable: false, value: 'createdBy.displayName' },
        { text: '', align: 'left', sortable: false, value: 'id' },
    ];

    clientId: string | null = null;
    since: string | null = null;
    until: string | null = null;
    showFilters = false;
    productId = Constants.NremEProductId;
    isBuy = false;
    partyProductId = null;
    amount = null;
    onlyDeposit = 0;
    im4ExchangeRate: ExchangeRateModel = null;
	pageIm4ExchangeRate: ExchangeRateModel = null;
    buyDialog = false;
    sellDialog = false;
    deleteDialog = false;
    buyDialogIsValid = false;
    sellDialogIsValid = false;
    saving = false;
    trade: TradeModel;
    wallets: WalletModel[];
    partyWalletCzk: WalletModel = null;
    partyWalletIm4: WalletModel = null;
    basicRules = [
        (v: any) => !!v || 'Toto pole je povinné.'
    ];
	customTime = false;
	tradeInitializating = false;
	im4ExchangeRateNotLoaded = false;
	tradeTime: string | null = null;
	tradeMaxTime: string | null = null;
	totalFreeShares = 0;
	computedBoughtShares = 0;
	selectedShareType = 0;
	selectedShares: ShareModel[] = [];
	transferDialog = false;
	transferDialogIsValid = true;
	destinationPartyProductId = null;
	destinationWallets: WalletModel[];
	destinationPartyWalletIm4: WalletModel = null;
	sharesToBuySearch = "";
	sharesToBuyDebounce: any = null;
	searchEvidenceNumberFrom: number | null = null;
	searchEvidenceNumberTo: number | null = null;
	foundSharesToSellCount: number | null = null;
	foundSharesToBuyCount: number | null = null;

	pageIndex = 1;
	pageSize = 50;

	@Ref() crudTable!: CrudTable;
    @Ref() buyForm!: any;
    @Ref() sellForm!: any;
    @Ref() transferForm!: any;

    @Watch("clientId")
    @Watch("since")
    @Watch("until")
    @Watch("onlyDeposit")
    filtersChanged(): void {
        this.loadData();
    }

	@Watch("pageIndex")
	@Watch("pageSize")
	paginationChanged() {
		this.loadData();
	}

	@Watch("partyProductId")
    partyProductIdChanged(v: string | null, p: string | null) {
        if (v != null && v != p) {
	        this.selectedShareType = 0;
	        this.selectedShares = [];
            this.getWallets();
			this.getSharesToBuy();
			this.getSharesToSell();
        }
    }

	@Watch("destinationPartyProductId")
	destinationPartyProductIdChanged(v: string | null, p: string | null) {
        if (v != null && v != p) {
	        this.getDestinationWallets();
        }
    }

	@Watch("sharesToBuySearch")
	sharesToBuySearchChanged(v: string, p: string) {
		clearTimeout(this.sharesToBuyDebounce);
		this.sharesToBuyDebounce = setTimeout(() => {
			this.getSharesToBuy();
		}, 500);
	}

	@Watch("selectedShares")
	selectedSharesChanged(v: ShareModel[]) {
		if (this.buyDialog) {
			this.computedBoughtShares = v?.length ?? 0;
			this.calculateAmountFromBoughtShares();
		}
		else if (this.sellDialog) {
			this.amount = v?.length ?? 0;
			this.computeBoughtShares();
		}

	}

    get newId(): string {
        return Guid.EmptyGuid();
    }

    get items(): TradeModel[] {
        return tradesStore.useGetter(CrudGetter.Data);
    }

    get walletSum(): number {
        const trades = tradesStore.useGetter(CrudGetter.Data) as TradeModel[];
        return trades.select(x => x.toAmount).sum();
    }

    get isSearchingSharesToSell(): boolean {
        return sharesStore.useGetter(CrudGetter.Pending, 'SearchSharedToSell');
    }

    get isSearchingSharesToBuy(): boolean {
        return sharesStore.useGetter(CrudGetter.Pending, 'SearchSharedToBuy');
    }

    get computedSoldSharesInCzk(): number | null {
        if (this.im4ExchangeRate == null) {
            return null;
        }
        return Number((this.amount * this.im4ExchangeRate.secondaryRate).toFixed(3));
    }

    get groupedDataDeposit(): any {
        const data = tradesStore.useGetter(CrudGetter.GroupedData, 'AmountDeposit');
        return data && data?.length > 0 ? data[0] : null;
    }

    get groupedDataWithdrawal(): any {
        const data = tradesStore.useGetter(CrudGetter.GroupedData, 'AmountWithdrawal');
        return data && data?.length > 0 ? data[0] : null;
    }

    get sharesToBuy(): ShareModel[] {
		return sharesStore.useGetter(CrudGetter.Data, 'SharesToBuy') ?? [];
    }

    get sharesToSell(): ShareModel[] {
        return sharesStore.useGetter(CrudGetter.Data, 'SharesToSell') ?? [];
    }

	get currentTotalTokenValueInCzk(): number | null {
		const deposit = tradesStore.useGetter(CrudGetter.GroupedData, 'AmountDeposit');
		const withdrawal = tradesStore.useGetter(CrudGetter.GroupedData, 'AmountWithdrawal');
		if (deposit != null && withdrawal != null && this.pageIm4ExchangeRate != null) {
			const currentTokens = deposit[0].amount - withdrawal[0].amount;
			return currentTokens * this.pageIm4ExchangeRate.rate;
		}
		return null;
	}

	get isFutureTradeTime(): boolean {
		if (this.tradeTime == null) {
			return false;
		}
		return moment(this.tradeTime).isAfter(moment());
	}

	isTokenAmountDecimal(amount: any): boolean {
		return !isNaN(amount) && Number(amount) % 1 != 0;
	}

	get totalRows (): number {
		return ({...tradesStore.useGetter(CrudGetter.PageInfo)} as CrudPageInfo)?.rowCount;
	}

    mounted(): void {
        this.loadData();
		this.getCurrentIm4Rate(true);
		this.getExchangeRates();

    }

    loadData(): void {
        let filters: CrudQueryPredicate[] = [
            { field: "partyProduct.productId", op: "eq", comparand: Constants.NremEProductId }
        ];
        filters = filters.concat(this.getFilters());
        tradesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TradeModel>([ { field: "time", index: 1, order: "desc" } ], filters, { pageIndex: this.pageIndex, pageSize: this.pageSize }));
        this.loadGroupedData();
    }

    getFilters(): CrudQueryPredicate[] {
      let filters: CrudQueryPredicate[] = [];
      if (this.clientId) {
        filters.push({ field: "partyProduct.partyId", op: "eq", comparand: this.clientId });
      }
      if (this.since) {
        filters.push({ field: "time", op: "gte", comparand: this.since });
      }
      if (this.until) {
        filters.push({ field: "time", op: "lte", comparand: this.until });
      }
      if (this.onlyDeposit == 1) {
        filters.push({ field: "fromCurrencyId", op: 'eq', comparand: Constants.CurrencyCzkId });
        filters.push({ field: "toCurrencyId", op: 'eq', comparand: Constants.CurrencyNremEId });
      }
      else if (this.onlyDeposit == 2) {
        filters.push({ field: "fromCurrencyId", op: 'eq', comparand: Constants.CurrencyNremEId });
        filters.push({ field: "toCurrencyId", op: 'eq', comparand: Constants.CurrencyCzkId });
      }
      return filters;
    }

    buyClick(): void {
        this.trade = {
            partyProductId: null,
            time: moment().format("YYYY-MM-DD HH:mm:ss"),
            fromAmount: null,
            toAmount: null,
	        shares: []
        } as TradeModel;
		this.tradeTime = this.trade.time;
        this.partyProductId = null;
        this.amount = 0;
        this.buyDialog = true;
		this.sharesToBuySearch = "";
        this.partyWalletCzk = null;
        this.partyWalletIm4 = null;
		this.customTime = false;
		this.tradeInitializating = true;
		this.tradeMaxTime = moment().format("YYYY-MM-DD 23:59:59");
		this.selectedShareType = 0;
		this.selectedShares = [];
		this.$nextTick(() => {
			this.tradeInitializating = false;
			this.getCurrentIm4Rate();
			this.getTotalFreeShares();
			this.getSharesToBuy();
		});
    }

    sellClick(): void {
        this.trade = {
            partyProductId: null,
            time: moment().format("YYYY-MM-DD HH:mm:ss"),
            fromAmount: null,
            toAmount: null,
	        shares: []
        } as TradeModel;
		this.tradeTime = this.trade.time;
        this.partyProductId = null;
        this.amount = 0;
        this.sellDialog = true;
        this.partyWalletCzk = null;
        this.partyWalletIm4 = null;
		this.customTime = false;
		this.tradeInitializating = true;
		this.tradeMaxTime = moment().format("YYYY-MM-DD 23:59:59");
	    this.selectedShareType = 0;
	    this.selectedShares = [];
		this.$nextTick(() => {
			this.tradeInitializating = false;
			this.getCurrentIm4Rate();
		});
    }

	transferClick(): void {
        this.trade = {
            partyProductId: null,
            time: moment().format("YYYY-MM-DD HH:mm:ss"),
            fromAmount: null,
            toAmount: null,
	        shares: []
        } as TradeModel;
		this.tradeTime = this.trade.time;
        this.partyProductId = null;
        this.destinationPartyProductId = null;
        this.amount = 0;
        this.transferDialog = true;
        this.partyWalletCzk = null;
        this.partyWalletIm4 = null;
        this.destinationPartyWalletIm4 = null;
		this.customTime = false;
		this.tradeInitializating = true;
		this.tradeMaxTime = moment().format("YYYY-MM-DD 23:59:59");
	    this.selectedShareType = 0;
	    this.selectedShares = [];
		this.$nextTick(() => {
			this.tradeInitializating = false;
			this.getCurrentIm4Rate();
		});
    }

    deleteClick(item: TradeModel) {
        this.deleteDialog = true;
        this.trade = item;
    }

	computeBoughtShares() {
		if (this.im4ExchangeRate == null) {
			return null;
		}
		if (this.selectedShareType == 2) {
			return null;
		}
		this.computedBoughtShares = Number((this.amount / this.im4ExchangeRate.secondaryRate).toFixed(3));
	}

	calculateAmountFromBoughtShares() {
		if (this.computedBoughtShares && this.im4ExchangeRate != null && this.im4ExchangeRate.secondaryRate != null) {
			this.amount = this.computedBoughtShares * this.im4ExchangeRate.secondaryRate;
		}
		else {
			this.amount = null;
		}
	}

    saveIm4ExchangeRate(): Promise<ExchangeRateModel> {
        return new Promise<ExchangeRateModel>((resolve, reject) => {
			debugger;
            if (this.im4ExchangeRate.id != Guid.EmptyGuid()) {
                resolve(this.im4ExchangeRate);
            }
            else {
                exchangeRatesStore.dispatch(CrudAction.Create, { item: {
                    fromDate: this.tradeTime,
                    toDate: this.tradeTime,
                    productId: Constants.NremEProductId,
                    rate: this.im4ExchangeRate.rate,
	                secondaryRate: this.im4ExchangeRate.secondaryRate,
                    type: ExchangeRateTypeEnum.Product,
                    isPublic: false
                } as ExchangeRateModel });
                this.subscribe(exchangeRatesStore, CrudAction.Create).then((e: ExchangeRateModel) => {
					debugger;
                    this.im4ExchangeRate = e;
                    resolve(e);
                }).catch((e) => reject(e));
            }
        });
    }

    saveItem(): void {
		this.trade.time = this.tradeTime;
        const e = cloneDeep(this.trade);
        if (e.id == null || e.id == Guid.EmptyGuid()) {
			this.saveIm4ExchangeRate().then(() => {
				if (this.buyDialog) {
			        if (this.buyForm.validate()) {
				        e.type = TradeTypeEnum.Buy;
				        e.partyProductId = this.partyProductId;
				        e.shares = this.selectedShares?.map(x => x.id) ?? [];
				        e.fromAmount = this.amount;
				        e.toAmount = Number((this.amount / this.im4ExchangeRate.secondaryRate).toFixed(3));
				        e.fromCurrencyId = Constants.CurrencyCzkId;
				        e.toCurrencyId = Constants.CurrencyNremEId;
				        e.tradeConversions = [
					        {
						        exchangeRateId: this.im4ExchangeRate.id,
						        fromAmount: this.amount,
						        toAmount: this.amount / this.im4ExchangeRate.secondaryRate
					        }
				        ];
				        this.saving = true;
				        tradesStore.dispatch(CrudAction.Create, { item: e });
				        this.subscribe(tradesStore, CrudAction.Create).then(() => {
					        this.buyDialog = false;
					        this.sellDialog = false;
					        this.saving = false;
					        this.loadData();
				        })
			        }
		        }
		        else if (this.sellDialog) {
			        if (this.sellForm.validate()) {
				        e.type = TradeTypeEnum.Sell;
				        e.partyProductId = this.partyProductId;
				        e.shares = this.selectedShares?.map(x => x.id) ?? [];
				        e.fromAmount = this.amount;
				        e.toAmount = Number((this.amount * this.im4ExchangeRate.secondaryRate).toFixed(3));
				        e.fromCurrencyId = Constants.CurrencyNremEId;
				        e.toCurrencyId = Constants.CurrencyCzkId;
				        e.tradeConversions = [
					        {
						        exchangeRateId: this.im4ExchangeRate.id,
						        fromAmount: this.amount,
						        toAmount: this.amount * this.im4ExchangeRate.secondaryRate
					        }
				        ];
				        this.saving = true;
				        tradesStore.dispatch(CrudAction.Create, { item: e });
				        this.subscribe(tradesStore, CrudAction.Create).then(() => {
					        this.buyDialog = false;
					        this.sellDialog = false;
					        this.saving = false;
					        this.loadData();
				        });
			        }
		        }
	        });
        }
    }

	saveTransferItem(): void {
		this.trade.time = this.tradeTime;
        const e = cloneDeep(this.trade);
        if (e.id == null || e.id == Guid.EmptyGuid()) {
	        if (this.transferForm.validate()) {
		        e.type = TradeTypeEnum.Transfer;
		        e.partyProductId = this.destinationPartyProductId;
				e.fromPartyProductId = this.partyProductId;
		        e.shares = this.selectedShares?.map(x => x.id) ?? [];
		        e.fromAmount = e.shares.length;
		        e.toAmount = e.shares.length;
		        e.fromCurrencyId = Constants.CurrencyNremEId;
		        e.toCurrencyId = Constants.CurrencyNremEId;
		        e.tradeConversions = [];
		        this.saving = true;
		        tradesStore.dispatch(CrudAction.Create, { item: e });
		        this.subscribe(tradesStore, CrudAction.Create).then(() => {
			        this.transferDialog = false;
			        this.saving = false;
			        this.loadData();
		        })
	        }
        }
    }

    removeItem(): void {
        this.saving = true;
        tradesStore.dispatch(CrudAction.Delete, createCrudQueryPayload<TransactionModel>(undefined, [ { field: "id", op: "eq", comparand: this.trade.id! } ]));
        this.subscribe(tradesStore, CrudAction.Delete).then(() => {
            this.saving = false;
            this.deleteDialog = false;
            this.loadData();
        }).catch(ex => {
            this.saving = false;
            console.log(ex);
        })
    }

    beforeAdd(e: WalletTransactionModel): void {
        this.amount = 0;
        this.partyProductId = null;
    }

    beforeEdit(e: WalletTransactionModel): void {
        this.isBuy = e.amount >= 0;
        this.amount = Math.abs(e.amount);
        this.partyProductId = e.wallet.partyProductId;
    }

    getCurrentIm4Rate(firstLoad = false): Promise<number | null> {
        return new Promise<number | null>((resolve, reject) => {
			const predicates = [
				{ field: 'productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
				{ field: 'type', op: QueryOperator.Eq, comparand: ExchangeRateTypeEnum.Product },
				{ field: 'isPublic', op: QueryOperator.Eq, comparand: true }
			];
			if (this.customTime) {
				predicates.push({ field: 'fromDate', op: QueryOperator.Lte, comparand: this.tradeTime });
				predicates.push({ field: 'toDate', op: QueryOperator.Gte, comparand: this.tradeTime });
			}
            ApiService.api.getExchangeRateBatch(1, 1, {
                predicates: predicates,
                orderby: [
                    { field: "toDate", index: 1, order: SortOrder.Desc }
                ]
            }).then((e: any) => {
                this.im4ExchangeRate = e.data.returnValue.items.firstOrDefault();
				if (this.im4ExchangeRate == null) {
					this.im4ExchangeRateNotLoaded = true;
					this.im4ExchangeRate = {
						id: Guid.EmptyGuid(),
						rate: null
					};
				}
				else {
					this.im4ExchangeRateNotLoaded = false;
				}
				if (firstLoad) {
					this.pageIm4ExchangeRate = {...this.im4ExchangeRate};
				}
				else {
					if (this.buyDialog) {
						this.calculateAmountFromBoughtShares();
					}
					else {
						this.computeBoughtShares();
					}
				}
				resolve(this.im4ExchangeRate.secondaryRate ?? null);
            }).catch((e: any) => reject(e));
        });
    }

	getExchangeRates() {
		exchangeRatesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ExchangeRateModel>([ { field: "fromDate", index: 1, order: "desc" } ], [ { field: "productId", op: "eq", comparand: Constants.NremEProductId } ], undefined, false, Constants.NremEProductId));
	}

	getTotalFreeShares(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			ApiService.api.getShareGroupped({
				predicates: [
					{ field: 'productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
					{ field: 'ownerId', op: QueryOperator.Eq, comparand: null }
				],
				groupby: [],
				projections: [
					{
						field: "id",
						aggregation: ProjectionAggregationEnum.Count,
						outputField: "count"
					} as GroupByProjectionDefinition
				]
			}).then((e) => {
				this.totalFreeShares = e.data.returnValue.firstOrDefault()?.count;
				resolve(this.totalFreeShares);
			}).catch((e: any) => reject(e));
		});
	}

	getSharesToBuy(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			const predicates: CrudQueryPredicate[] = [
				{ field: 'ownerId', op: QueryOperator.Eq, comparand: null }
			];
			if (this.sharesToBuySearch && !isNaN(Number(this.sharesToBuySearch))) {
				predicates.push({
					field: 'evidenceNumber',
					op: QueryOperator.Gte,
					comparand: Number(this.sharesToBuySearch) - 2
				});
			}
			sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, predicates, { pageIndex: 1, pageSize: 10 }, false, 'SharesToBuy'))
		});
	}

	getSharesToSell(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
				{ field: 'ownerId', op: QueryOperator.Eq, comparand: this.partyProductId ?? Guid.EmptyGuid() }
			], undefined, false, 'SharesToSell'))
		});
	}

    getWallets(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            ApiService.api.getWalletBatch(1, 99, {
                predicates: [
                    { field: 'partyProductId', op: QueryOperator.Eq, comparand: this.partyProductId }
                ]
            }).then((e: any) => {
                this.wallets = e.data.returnValue.items;
                this.partyWalletCzk = this.wallets.firstOrDefault(x => x.currencyId == Constants.CurrencyCzkId && x.partyProductId == this.partyProductId);
                this.partyWalletIm4 = this.wallets.firstOrDefault(x => x.currencyId == Constants.CurrencyNremEId && x.partyProductId == this.partyProductId);
                resolve(this.wallets);
            }).catch((e: any) => reject(e));
        });
    }

	getDestinationWallets(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            ApiService.api.getWalletBatch(1, 99, {
                predicates: [
                    { field: 'partyProductId', op: QueryOperator.Eq, comparand: this.destinationPartyProductId }
                ]
            }).then((e: any) => {
				this.destinationWallets = e.data.returnValue.items;
                this.destinationPartyWalletIm4 = this.destinationWallets.firstOrDefault(x => x.currencyId == Constants.CurrencyNremEId && x.partyProductId == this.destinationPartyProductId);
                resolve(this.wallets);
            }).catch((e: any) => reject(e));
        });
    }

    getIm4RateOfTrade(item: TradeModel): number | null {
        return item.tradeConversions.firstOrDefault(x => x.exchangeRate.type == ExchangeRateTypeEnum.Product)?.exchangeRate.secondaryRate ?? null;
    }

    loadGroupedData(): void {
        tradesStore.dispatch(CrudAction.GetGrouped, createGroupedQueryPayload<TradeModel>([
            { field: 'fromCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyCzkId },
            { field: 'toCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyNremEId }
        ].concat(this.getFilters() as any), [], [
            {
                field: "toAmount",
                aggregation: ProjectionAggregationEnum.Sum,
                outputField: "amount"
            } as GroupByProjectionDefinition
        ], 'AmountDeposit'));
        tradesStore.dispatch(CrudAction.GetGrouped, createGroupedQueryPayload<TradeModel>([
            { field: 'fromCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyNremEId },
            { field: 'toCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyCzkId }
        ].concat(this.getFilters() as any), [], [
            {
                field: "fromAmount",
                aggregation: ProjectionAggregationEnum.Sum,
                outputField: "amount"
            } as GroupByProjectionDefinition
        ], 'AmountWithdrawal'));
    }

	tradeTimeChanged(): void {
		if (!this.tradeInitializating) {
			this.customTime = true;
			this.getCurrentIm4Rate();
		}
	}

	hasCorrectExchangeRate(trade: TradeModel): boolean {
		const exchangeRates = exchangeRatesStore.useGetter(CrudGetter.Data, Constants.NremEProductId) as ExchangeRateModel[];
		if (exchangeRates && exchangeRates.any()) {
			const exchangeRate = exchangeRates.where(x => Date.parse(x.fromDate) <= Date.parse(trade.time) && Date.parse(x.toDate) >= Date.parse(trade.time)).firstOrDefault();
			if (exchangeRate) {
				return exchangeRate.secondaryRate == this.getIm4RateOfTrade(trade);
			}
		}
		return true;
	}

	getValidExchangeRate(trade: TradeModel): number {
		const exchangeRates = exchangeRatesStore.useGetter(CrudGetter.Data, Constants.NremEProductId) as ExchangeRateModel[];
		if (exchangeRates && exchangeRates.any()) {
			const exchangeRate = exchangeRates.where(x => Date.parse(x.fromDate) <= Date.parse(trade.time) && Date.parse(x.toDate) >= Date.parse(trade.time)).firstOrDefault();
			if (exchangeRate && exchangeRate.secondaryRate) {
				return exchangeRate.secondaryRate;
			}
		}
		return 0;
	}

	searchSharedToSell() {
		this.foundSharesToSellCount = null;
		sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
			{ field: 'productId', op: QueryOperator.Eq, comparand: this.productId! },
			{ field: 'ownerId', op: QueryOperator.Eq, comparand: this.partyProductId! },
			{ field: 'evidenceNumber', op: QueryOperator.Gte, comparand: Number(this.searchEvidenceNumberFrom) },
			{ field: 'evidenceNumber', op: QueryOperator.Lte, comparand: Number(this.searchEvidenceNumberTo) }
		], undefined, false, 'SearchSharedToSell'));
		this.subscribe(sharesStore, CrudAction.GetAll, 'SearchSharedToSell').then((e: ShareModel[]) => {
			this.foundSharesToSellCount = e.length;
			this.selectedShares = [...e];
			this.selectedSharesChanged(this.selectedShares);
		});
	}

	searchSharedToBuy() {
		this.foundSharesToSellCount = null;
		sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
			{ field: 'productId', op: QueryOperator.Eq, comparand: this.productId! },
			{ field: 'ownerId', op: QueryOperator.Eq, comparand: null },
			{ field: 'evidenceNumber', op: QueryOperator.Gte, comparand: Number(this.searchEvidenceNumberFrom) },
			{ field: 'evidenceNumber', op: QueryOperator.Lte, comparand: Number(this.searchEvidenceNumberTo) }
		], undefined, false, 'SearchSharedToBuy'));
		this.subscribe(sharesStore, CrudAction.GetAll, 'SearchSharedToBuy').then((e: ShareModel[]) => {
			this.foundSharesToBuyCount = e.length;
			this.selectedShares = [...e];
			this.selectedSharesChanged(this.selectedShares);
		});
	}

	clearSelectedShared() {
		this.selectedShares = [];
		this.selectedSharesChanged(this.selectedShares);
		this.searchEvidenceNumberFrom = null;
		this.searchEvidenceNumberTo = null;
		this.foundSharesToSellCount = null;
		this.foundSharesToBuyCount = null;
	}

}
